import { TABLE_SKELETON_ROW_COUNT } from 'shared/ui/table-skeleton';
export const defaultLimit = (owner) => ({
    id: null,
    productId: 'productId' in owner ? owner.productId : null,
    cardId: 'cardId' in owner ? owner.cardId : null,
    limitScope: 'TOTAL_SPEND',
    windowType: 'DAILY',
    amountLimit: null,
    countLimit: 0,
    currencyCode: '',
    isOverride: false,
    status: 'ACTIVE',
    appliesToChannel: 'ATM',
    appliesToCountry: 'DOMESTIC',
    effectiveFrom: null,
    effectiveUntil: null,
});
/** Placeholder rows for loading skeleton UI (negative ids are never from the API). */
export const buildSkeletonLimitRows = (owner) => Array.from({ length: TABLE_SKELETON_ROW_COUNT }, (_, i) => ({
    ...defaultLimit(owner),
    id: -(i + 1),
}));
